import { TYPES } from "../../EntityManager";
import { Picker } from "./Picker";

export class PitPicker extends Picker {
    constructor(props) {
        super({
            ...props,
            type: TYPES.PIT,
            events: {
                on: {
                    select: 'ADD_TICKET_PIT',
                    unselect: 'REMOVE_TICKET_PIT'
                },
                trigger: {
                    select: 'ON_SELECT_PIT',
                    unselect: 'ON_SELECT_PIT'
                }
            }
        });
    }
}